'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var Steps = function (_Component) {
  _inherits(Steps, _Component);

  function Steps() {
    _classCallCheck(this, Steps);

    return _possibleConstructorReturn(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).apply(this, arguments));
  }

  _createClass(Steps, [{
    key: 'getStatus',
    value: function getStatus(index) {
      var status = '';
      var _props$currentStep = this.props.currentStep,
          currentStep = _props$currentStep === undefined ? 1 : _props$currentStep;

      if (currentStep > index) {
        status = 'complete';
      } else if (currentStep === index) {
        status = 'current';
      }
      return status;
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _this2 = this;

      var _props = this.props,
          kind = _props.kind,
          children = _props.children,
          _props$showTooltip = _props.showTooltip,
          showTooltip = _props$showTooltip === undefined ? false : _props$showTooltip;

      return _react2.default.Children.map(children, function (child, index) {
        var status = _this2.getStatus(index + 1);
        var isLastChild = index === _react2.default.Children.count(children) - 1;
        return _react2.default.cloneElement(child, {
          kind: kind,
          status: status,
          showTooltip: showTooltip,
          isLastChild: isLastChild
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          kind = _props2.kind,
          style = _props2.style,
          className = _props2.className,
          showTooltip = _props2.showTooltip,
          currentStep = _props2.currentStep,
          children = _props2.children,
          otherProps = _objectWithoutProperties(_props2, ['kind', 'style', 'className', 'showTooltip', 'currentStep', 'children']);

      var stepsClasses = (0, _classnames2.default)("a-steps", {
        'a-steps-timeline': kind === 'timeline',
        'a-steps-horizontal step-tracker--center ': kind === 'steps'
      });
      return _react2.default.createElement(
        'ol',
        Object.assign({ style: style, className: stepsClasses }, otherProps),
        this.renderChildren()
      );
    }
  }]);

  return Steps;
}(_react.Component);

Steps.defaultProps = {
  kind: 'steps'
};


Steps.propTypes = {
  kind: _propTypes2.default.oneOf(["timeline", "steps"]),
  currentStep: _propTypes2.default.number,
  showTooltip: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};

Steps.displayName = 'Steps';

exports.default = Steps;